export default class UnsupportedBrowser {
  constructor( element ) {
    element.classList.add('javascript');
    if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
      element.style.display = 'block';
    }
  }
}
